/**
 * Rate Limit Page - Countdown timer y progress bar
 */

function initRateLimitCountdown() {
    const countdownElement = document.getElementById('countdown');
    if (!countdownElement) return;

    const retryAfter = parseInt(countdownElement.dataset.seconds, 10);
    if (isNaN(retryAfter) || retryAfter <= 0) return;

    let timeLeft = retryAfter;
    const progressBar = document.querySelector('.progress-bar');
    const initialTime = timeLeft;

    function updateCountdown() {
        if (timeLeft <= 0) {
            countdownElement.textContent = '0';
            if (progressBar) {
                progressBar.style.width = '100%';
            }

            // Auto-refresh después de un pequeño delay
            setTimeout(function () {
                location.reload();
            }, 1000);
            return;
        }

        countdownElement.textContent = timeLeft;
        const progress = ((initialTime - timeLeft) / initialTime) * 100;
        if (progressBar) {
            progressBar.style.width = progress + '%';
        }

        timeLeft--;
        setTimeout(updateCountdown, 1000);
    }

    updateCountdown();
}

document.addEventListener('DOMContentLoaded', initRateLimitCountdown);
